// انتقالِ کلیدهای مرورگر — **باید پیش از خواندنِ هر کلیدی اجرا شود**،
// از جمله deviceId که همین پایین ساخته می‌شود.
import "./storage-migrate";
/**
 * نشانیِ سرور.
 *
 * پیش‌فرض «هم‌ریشه» است: در توسعه، ویت درخواست‌های /v1 و /ws را به bazivandِ محلی
 * پراکسی می‌کند، و در تولید همان bazivand فایل‌های ساخته‌شده را سرو می‌کند. پس در
 * هیچ‌کدام نشانیِ سخت‌کدشده لازم نیست — همان چیزی که در نسخه‌ی موبایل دردسر شد.
 *
 * برای آزمودن مقابلِ سرورِ دیگر: `?server=http://192.168.1.4:8842` در نشانیِ صفحه.
 * فقط نشانیِ محلی و فقط از صفحه‌ی محلی — چرایش در net/origin.ts.
 */
import { serverOrigin } from "./origin";
import { captureSource } from "./source";
// بی‌DOM هم باید بار شود: آزمون‌ها این ماژول را در node اجرا می‌کنند.
const hasDom = typeof location !== "undefined";
const qs = new URLSearchParams(hasDom ? location.search : "");

// ‎/r/<code> ← ‎/play?src=<code>: پیش از هر چیز نگهش داریم تا سرِ ساختنِ مهمان برسد.
if (hasDom) captureSource(location.search);

export const serverBase: string = serverOrigin();

export function httpUrl(path: string): string {
  return serverBase + path;
}

export function wsUrl(path: string): string {
  const base = serverBase || (hasDom ? location.origin : "http://127.0.0.1:8842");
  return base.replace(/^http/, "ws") + path;
}

/**
 * شناسه‌ی دستگاه که حسابِ مهمان به آن بسته است.
 *
 * در حافظه‌ی مرورگر می‌مانَد تا بعد از تازه‌کردنِ صفحه همان بازیکن برگردد و سرور
 * او را سرِ میزِ قبلی بنشانَد. دو زبانه‌ی یک مرورگر همین شناسه را می‌بینند و سرور
 * آن‌ها را یک نفر می‌شمارد، پس برای آزمونِ دو‌نفره روی یک کامپیوتر
 * `?device=b` را به نشانی اضافه کن.
 */
export const deviceId: string = (() => {
  const forced = qs.get("device");
  if (forced) return "web-" + forced;
  try {
    let id = localStorage.getItem("bazivan.device");
    if (!id) {
      id = "web-" + crypto.randomUUID();
      localStorage.setItem("bazivan.device", id);
    }
    return id;
  } catch {
    return "web-" + Math.random().toString(36).slice(2);
  }
})();

/**
 * شناسه‌ی تازه، جای شناسه‌ای که سرور با «device_taken» پس زد.
 *
 * شناسه به‌تنهایی دیگر حساب را باز نمی‌کند: کلیدش در کوکیِ HttpOnly است و سرور هر دو را
 * می‌خواهد (Backend/cmd/bazivand/device_key.go). مرورگری که شناسه را دارد و کلید را نه —
 * کوکی‌اش پاک شده، یا حسابِ ثبت‌شده‌ای که پیش از کلید روی همین مرورگر بود — با شناسه‌ی
 * تازه ادامه می‌دهد و حساب با نام و رمز برمی‌گردد.
 */
export function renewDeviceId(): string {
  const id = "web-" + (typeof crypto !== "undefined" && crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2));
  try { localStorage.setItem("bazivan.device", id); } catch { /* حالتِ ناشناس */ }
  return id;
}
